<div class="row">
  <div class="col-8">
    <div class="card mt-4 p-4">
      <div class="card-body">
        <h1 class="card-title text-primary custom-tile-header">External Access</h1>
        <p>
          Please provide website admin login credentials here. If a new user needs to be created for our access please use the
          email <a href="mailto:data@connectreporting.com">data&#64;connectreporting.com</a>, and if available enable the "login
          with Google" option. The admin user cannot have 2FA enabled.
        </p>

        <div *ngIf="!loading">
          <app-website-access [inputAccountTypes]="[customerAccountTypes.CMSAdminAccess]" [hideHelpText]="true"
            (credentialsSaved)="credentialsProvided()"></app-website-access>
        </div>
      </div>
    </div>
  </div>
</div>
